import type { getNewContractFormSchema } from "web_myplann/Goals/Forms/newContractFormSchema";
import type { NewContractMissingKey } from "web_myplann/Goals/Types/NewContractMissingKey";

export const getNewContractMissingKey = (
	schema: ReturnType<typeof getNewContractFormSchema>,
	name: string,
	value: number | null,
): NewContractMissingKey | null => {
	const isNameValid = schema.shape.name.safeParse(name).success;
	const isValueValid = schema.shape.value.safeParse(value).success;

	if (isNameValid && isValueValid) return null;
	if (!isNameValid && !isValueValid) return "both";
	return isNameValid ? "value" : "name";
};
